import { useState } from 'react'
import InputFormCard from '@component/InputFormCard'
import UnitAdornment from '@component/UnitAdornment'
import { TextField } from '@mui/material'
import { useHistoryList } from '@component/HistoryList'
import { useTranslation } from 'react-i18next'
import { Query } from '@core/query'
import { Controller } from 'react-hook-form'
import { useBeam } from './context'
import { makeFormRules, toMillimeter } from '@/utils'

function BeamForm () {
  const { t } = useTranslation()
  const { form, setResult } = useBeam()
  const { appendHistory } = useHistoryList()

  const {
    control,
    reset,
    handleSubmit,
  } = form

  const rules = makeFormRules()

  const [isLoading, setLoading] = useState(false)
  const onSubmit = handleSubmit(async _ => {
    if (_.beamSpan <= 0 || _.rebarStrength <= 0) {
      alert(t('SENTENCE.CHECK_YOUR_INPUT'))
      return
    }

    setLoading(true)
    const res = await Query.requestCalcBeam(_)
    setLoading(false)

    const needDepth = toMillimeter(res.needDepth)
    setResult(needDepth)
    appendHistory({
      type: 'Beam',
      ..._,
      result: needDepth,
    })
  })

  const onReset = () => {
    reset()
    setResult(null)
  }

  return (
    <InputFormCard
      title={t('GLOSSARY.BEAM')}
      onReset={onReset}
      onSubmit={onSubmit}
      loading={isLoading}
    >
      <Controller
        control={control}
        name="rebarStrength"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.REBAR_STRENGTH')}
            InputProps={{
              endAdornment: <UnitAdornment unit="MPa" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
      <Controller
        control={control}
        name="beamSpan"
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.BEAM_SPAN')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
    </InputFormCard>
  )
}

export default BeamForm
